import entityManager from '../lib/entityManager';
import { Dead } from '../components';

/**
 * The CleanupSystem is responsible for removing entities from the game
 * that are marked for deletion (e.g., they are Dead).
 */
export default class CleanupSystem {
  update() {
    const deadEntities = entityManager.query([Dead]);

    if (deadEntities.length > 0) {
      deadEntities.forEach(entity => {
        // The SpatialSystem will automatically handle the removal of the sprite
        // in its own update loop when it sees the entity is gone.
        entity.destroy();
      });
    }
  }
}
